import { render, staticRenderFns } from "./CCorruptedFilesModal.vue?vue&type=template&id=1c4cbc4a&scoped=true&"
import script from "./CCorruptedFilesModal.vue?vue&type=script&lang=ts&"
export * from "./CCorruptedFilesModal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c4cbc4a",
  null
  
)

export default component.exports